import React, { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Checkbox
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";

const CommunityNotificationSendPopup = ({ open, onClose, community }) => {
    const [formData, setFormData] = useState({
        community: community._id,
        title: "",
        description: "",
        mediaUrl: "", // image to send
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log({
            title: formData.title,
            description: formData.description,
            image: formData.mediaUrl,
            community: formData.community
        })
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${BASE_URL}/community/scmnotification`, {
                method: "POST",
                headers: {
                    "auth-token": token,  // ✅ Do NOT set Content-Type manually
                    "content-type": 'application/json'
                },
                body: JSON.stringify({
                    title: formData.title,
                    description: formData.description,
                    image: formData.image,
                    community: formData.community
                })
            });

            const json = await response.json();
            console.log(json);

            if (json.success === true) {
                alert("Notification has been sent.");
                onClose();
            } else {
                alert(`${json.response}`);
            }

        } catch (error) {
            console.error("error:", error);
            alert(`Failed to send notification, please try again later.`);
        }
    };


    return (
        <Dialog open={open} onClose={onClose} >
            <DialogTitle style={{ background: "#202020", fontFamily: "poppins-mid" }}>Send Notification to {community.title}</DialogTitle>
            <DialogContent style={{ background: "#202020" }}>
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <TextField fullWidth margin="dense" label="Notification title..." name="title" value={formData.title} onChange={handleChange}
                        sx={{
                            fontSize: "14px",
                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",  // Change label font family
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ffffff20", borderRadius: "10px" },
                                "&:hover fieldset": { borderColor: "#ffffff20", borderRadius: "10px" },
                                "&.Mui-focused fieldset": { borderColor: "#ffffff20", borderRadius: "10px" },
                            },
                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg", // Change font family
                                fontSize: "14px", // Change font size
                            },
                        }}
                    />
                    <TextField fullWidth margin="dense" label="Description" name="description" value={formData.description} onChange={handleChange} required multiline rows={3}
                        sx={{
                            fontSize: "14px",
                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",  // Change label font family
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                            },
                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg", // Change font family
                                fontSize: "14px", // Change font size
                            },
                        }} />

                    <TextField fullWidth margin="dense" label="Image url" name="image" value={formData.image} onChange={handleChange} multiline rows={3}
                        sx={{
                            fontSize: "14px",
                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",  // Change label font family
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                            },
                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg", // Change font family
                                fontSize: "14px", // Change font size
                            },
                        }} />



                    {/* File Upload */}




                    <DialogActions>
                        <Button onClick={onClose} style={{ fontFamily: "poppins-reg", color: "#ffffff" }}>Cancel</Button>
                        <Button type="submit" style={{ fontFamily: "poppins-reg", color: "#ffffff", background: "#706dea" }} variant="contained">Send Notification</Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default CommunityNotificationSendPopup;
